import React, { useState } from 'react';
import '../../../assets/css/general/subscription/Subscription.css';
import AppNavbar from '../../../components/customer/dashboard/apphome/appnavbar/AppNavbar';

// ── Plan Data ──
const PLANS = [
  {
    id: 'basic',
    name: 'Basic',
    badge: null,
    price: 0,
    period: 'month',
    tagline: 'Get started for free',
    color: '#888',
    features: [
      'Browse service providers',
      'Post up to 2 jobs/month',
      'Basic customer support',
      'Standard search filters',
    ],
    cta: 'Current Plan',
    disabled: true,
  },
  {
    id: 'pro',
    name: 'Pro',
    badge: 'POPULAR',
    price: 1299,
    period: 'month',
    tagline: 'Best for regular users',
    color: '#0491e1',
    features: [
      'Unlimited job postings',
      'Priority provider matching',
      'Real-time chat with workers',
      'Verified provider access',
      'Early booking slots',
    ],
    cta: 'Get Pro',
    disabled: false,
  },
  {
    id: 'elite',
    name: 'Elite',
    badge: 'BEST VALUE',
    price: 2499,
    period: 'month',
    tagline: 'Maximum perks & savings',
    color: '#7c3aed',
    features: [
      'Everything in Pro',
      'Dedicated account manager',
      'Instant worker dispatch',
      'Priority dispute resolution',
      'Exclusive elite-only workers',
      'Monthly service credits',
    ],
    cta: 'Get Elite',
    disabled: false,
  },
];

const REVIEWS = [
  { text: "Picks4Tips Pro changed how I manage home services. Super fast bookings!", author: "Ayesha K., Lahore" },
  { text: "Got my AC fixed within 2 hours. The priority matching is unreal.", author: "Bilal M., Karachi" },
  { text: "Elite plan worth every rupee. My go-to for all home needs.", author: "Sara R., Islamabad" },
];

// ── Payment Modal ──
const PaymentModal = ({ plan, onClose, onSuccess }) => {
  const [cardNumber, setCardNumber] = useState('');
  const [expiry, setExpiry]         = useState('');
  const [cvv, setCvv]               = useState('');
  const [name, setName]             = useState('');
  const [loading, setLoading]       = useState(false);

  const formatCard = (val) => val.replace(/\D/g, '').slice(0, 16).replace(/(.{4})/g, '$1 ').trim();
  const formatExpiry = (val) => {
    const v = val.replace(/\D/g, '').slice(0, 4);
    return v.length >= 3 ? v.slice(0,2) + '/' + v.slice(2) : v;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setTimeout(() => { setLoading(false); onSuccess(); }, 2000);
  };

  return (
    <>
  
    <div className="sub-modal-overlay" onClick={onClose}>
      <div className="sub-modal" onClick={e => e.stopPropagation()}>

        {/* Mobile close */}
        <button className="sub-modal__close" onClick={onClose}>✕</button>

        <div className="sub-modal__inner">

          {/* Left — Payment form */}
          <div className="sub-modal__left">
            <h3 className="sub-modal__form-title">Payment Method</h3>

            <form onSubmit={handleSubmit} className="sub-pay-form">
              <div className="sub-pay-form__field">
                <label>Cardholder Name</label>
                <input
                  type="text"
                  placeholder="Full name on card"
                  value={name}
                  onChange={e => setName(e.target.value)}
                  required
                />
              </div>

              <div className="sub-pay-form__field">
                <label>Card Number</label>
                <div className="sub-pay-form__card-wrap">
                  <input
                    type="text"
                    placeholder="0000 0000 0000 0000"
                    value={cardNumber}
                    onChange={e => setCardNumber(formatCard(e.target.value))}
                    required
                  />
                  <div className="sub-pay-form__card-icons">
                    <span>VISA</span>
                    <span>MC</span>
                  </div>
                </div>
              </div>

              <div className="sub-pay-form__row">
                <div className="sub-pay-form__field">
                  <label>Expiry Date</label>
                  <input
                    type="text"
                    placeholder="MM/YY"
                    value={expiry}
                    onChange={e => setExpiry(formatExpiry(e.target.value))}
                    required
                  />
                </div>
                <div className="sub-pay-form__field">
                  <label>Security Code</label>
                  <input
                    type="text"
                    placeholder="CVV"
                    value={cvv}
                    onChange={e => setCvv(e.target.value.replace(/\D/g,'').slice(0,3))}
                    required
                  />
                </div>
              </div>

              <button type="submit" className="sub-pay-form__btn" disabled={loading}>
                {loading ? <span className="sub-spinner"/> : `Subscribe — Rs ${plan.price.toLocaleString()}/mo`}
              </button>

              <p className="sub-pay-form__secure">🔒 Secured · Cancel anytime</p>
            </form>
          </div>

          {/* Right — Plan summary */}
          <div className="sub-modal__right" style={{ '--plan-color': plan.color }}>
            <div className="sub-modal__plan-name">{plan.name} Plan</div>
            <p className="sub-modal__plan-tag">{plan.tagline}</p>

            <div className="sub-modal__features">
              <p className="sub-modal__features-label">Top features</p>
              {plan.features.map((f, i) => (
                <div key={i} className="sub-modal__feature-item">
                  <span className="sub-modal__feature-check">✓</span>
                  {f}
                </div>
              ))}
            </div>

            <div className="sub-modal__summary">
              <div className="sub-modal__summary-row">
                <span>Monthly subscription</span>
                <span>Rs {plan.price.toLocaleString()}</span>
              </div>
              <div className="sub-modal__summary-row">
                <span>Estimated tax</span>
                <span>Rs 0</span>
              </div>
              <div className="sub-modal__summary-row sub-modal__summary-total">
                <span>Due today</span>
                <span>Rs {plan.price.toLocaleString()}</span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    </>
  );
};

// ── Success Modal ──
const SuccessModal = ({ plan, onClose }) => (
  <div className="sub-modal-overlay" onClick={onClose}>
    <div className="sub-success" onClick={e => e.stopPropagation()}>
      <div className="sub-success__icon">🎉</div>
      <h3>You're on {plan.name}!</h3>
      <p>Welcome to Picks4Tips {plan.name}. Your subscription is now active.</p>
      <button className="sub-success__btn" onClick={onClose}>Continue</button>
    </div>
  </div>
);

// ── Main Page ──
const Subscription = () => {
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [showPayment,  setShowPayment]  = useState(false);
  const [showSuccess,  setShowSuccess]  = useState(false);
  const [reviewIdx,    setReviewIdx]    = useState(0);
  const [billing,      setBilling]      = useState('monthly'); // monthly | yearly

  const handleContinue = (plan) => {
    if (plan.disabled) return;
    setSelectedPlan(plan);
    setShowPayment(true);
  };

  const handleSuccess = () => {
    setShowPayment(false);
    setShowSuccess(true);
  };

  return (
    <>
      <AppNavbar/>
    <div className="sub-page">

      {/* ── MOBILE LAYOUT ── */}
      <div className="sub-mobile">

        {/* Background blobs */}
        <div className="sub-mob__blob sub-mob__blob--1" />
        <div className="sub-mob__blob sub-mob__blob--2" />

        {/* Skip */}
        <div className="sub-mob__topbar">
          <div className="sub-mob__logo">WorkHub</div>
          <button className="sub-mob__skip">Skip</button>
        </div>

        {/* Review carousel */}
        <div className="sub-mob__review">
          <div className="sub-mob__review-stars">★★★★★</div>
          <p className="sub-mob__review-text">"{REVIEWS[reviewIdx].text}"</p>
          <span className="sub-mob__review-author">by {REVIEWS[reviewIdx].author}</span>
          <div className="sub-mob__review-dots">
            {REVIEWS.map((_, i) => (
              <button key={i} className={`sub-mob__dot ${i === reviewIdx ? 'active' : ''}`} onClick={() => setReviewIdx(i)} />
            ))}
          </div>
        </div>

        {/* Title */}
        <h2 className="sub-mob__title">Choose Your Plan</h2>

        {/* Plan toggles */}
      {/* Mobile cards */}
<div className="sub-mob__cards">
  {PLANS.filter(p => !p.disabled).map((plan) => (
    <div
      key={plan.id}
      className={`sub-mob__card ${selectedPlan?.id === plan.id ? 'active' : ''}`}
      style={{ '--plan-color': plan.color }}
      onClick={() => setSelectedPlan(plan)}
    >

      {plan.badge && (
        <div className="sub-mob__card-badge">
          {plan.badge}
        </div>
      )}

      <h3 className="sub-mob__card-name">
        {plan.name}
      </h3>

      <p className="sub-mob__card-tag">
        {plan.tagline}
      </p>

      <div className="sub-mob__card-price">
        Rs {plan.price.toLocaleString()}
      </div>

      <div className="sub-mob__card-day">
        Rs {Math.round(plan.price / 30)}/day
      </div>

    </div>
  ))}
</div>

        {/* Continue button */}
        <button
          className="sub-mob__cta"
          disabled={!selectedPlan}
          onClick={() => selectedPlan && handleContinue(selectedPlan)}
        >
          Continue
        </button>

        {/* Footer links */}
        <div className="sub-mob__footer">
          <span>Terms</span>
          <span>·</span>
          <span>Privacy</span>
          <span>·</span>
          <span>Restore</span>
        </div>
      </div>

      {/* ── DESKTOP LAYOUT ── */}
      <div className="sub-desktop">

        {/* Background */}
        <div className="sub-desk__bg" />

        {/* Header */}
        <div className="sub-desk__header">
          <h1 className="sub-desk__title">Choose Your Plan</h1>
          <p className="sub-desk__sub">Unlock the full Picks4Tips experience</p>

          {/* Billing toggle */}
          <div className="sub-desk__billing-toggle">
            <button
              className={`sub-desk__billing-btn ${billing === 'monthly' ? 'active' : ''}`}
              onClick={() => setBilling('monthly')}
            >Monthly</button>
            <button
              className={`sub-desk__billing-btn ${billing === 'yearly' ? 'active' : ''}`}
              onClick={() => setBilling('yearly')}
            >Yearly <span className="sub-desk__save-badge">Save 20%</span></button>
          </div>
        </div>

        {/* Plan cards */}
        <div className="sub-desk__cards">
          {PLANS.map((plan) => {
            const price = billing === 'yearly' ? Math.round(plan.price * 0.8) : plan.price;
            return (
              <div
                key={plan.id}
                className={`sub-desk__card ${plan.badge === 'POPULAR' ? 'sub-desk__card--featured' : ''}`}
                style={{ '--plan-color': plan.color }}
              >
                {plan.badge && (
                  <div className="sub-desk__card-badge">{plan.badge}</div>
                )}

                <div className="sub-desk__card-top">
                  <h3 className="sub-desk__card-name">{plan.name}</h3>
                  <p className="sub-desk__card-tagline">{plan.tagline}</p>
                  <div className="sub-desk__card-price">
                    <span className="sub-desk__price-currency">Rs</span>
                    <span className="sub-desk__price-amount">{price.toLocaleString()}</span>
                    <span className="sub-desk__price-period">/month</span>
                  </div>
                </div>

                <ul className="sub-desk__card-features">
                  {plan.features.map((f, i) => (
                    <li key={i}>
                      <span className="sub-desk__check" style={{ color: plan.color }}>✓</span>
                      {f}
                    </li>
                  ))}
                </ul>

                <button
                  className={`sub-desk__card-btn ${plan.disabled ? 'sub-desk__card-btn--disabled' : ''}`}
                  style={!plan.disabled ? { background: plan.color } : {}}
                  disabled={plan.disabled}
                  onClick={() => handleContinue(plan)}
                >
                  {plan.cta}
                </button>
              </div>
            );
          })}
        </div>

        <p className="sub-desk__footer">Secured by payment gateway · Cancel anytime · No hidden charges</p>
      </div>

      {/* ── MODALS ── */}
      {showPayment && selectedPlan && (
        <PaymentModal
          plan={selectedPlan}
          onClose={() => setShowPayment(false)}
          onSuccess={handleSuccess}
        />
      )}

      {showSuccess && selectedPlan && (
        <SuccessModal
          plan={selectedPlan}
          onClose={() => setShowSuccess(false)}
        />
      )}

    </div>
    </>
  );
};

export default Subscription;